module.exports = __webpack_public_path__ + "static/img/img7.bc5994d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/img7.png
// module id = LzVM
// module chunks = 1